import { AxiosResponse } from 'axios';
import { NotificationType } from 'pages/private/owner/AthleteDetail/components/Communications/types';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { PaginatedNotificationList, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
  queryKey: (string | undefined)[];
}

interface IUseCommunications {
  search?: string;
  ordering?: string;
  athleteId: string;
  limit?: string;
  notificationType?: NotificationType;
  createdAtStart?: string;
  createdAtEnd?: string;
}

function useCommunications({
  ordering,
  athleteId,
  limit = '20',
  notificationType,
  createdAtStart,
  createdAtEnd,
}: IUseCommunications): UseInfiniteQueryResult<AxiosResponse<PaginatedNotificationList>> {
  const fetchCommunications = ({
    pageParam = { limit, offset: '0' },
  }: QueryKeyType): Promise<AxiosResponse<PaginatedNotificationList>> => {
    const params = pageParam;

    params.athlete = athleteId;

    if (notificationType) {
      params.notification_type = notificationType;
    }

    if (createdAtStart) {
      params.created_at_start = createdAtStart;
    }
    if (createdAtEnd) {
      params.created_at_end = createdAtEnd;
    }

    if (ordering) {
      params.ordering = ordering.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`).concat(',pk');
    }

    return client.get(`notifications/?${encodeUrlParams(params)}`);
  };

  return useInfiniteQuery(
    ['communications', athleteId, notificationType, createdAtStart, createdAtEnd, ordering],
    fetchCommunications,
    {
      getNextPageParam: page => {
        return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
      },
    },
  );
}

export default useCommunications;
